import { render, staticRenderFns } from "./TotalCountReport.vue?vue&type=template&id=a7bf8ad6"
import script from "./TotalCountReport.vue?vue&type=script&lang=js"
export * from "./TotalCountReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports